<template>
  <div id="checkout_steps_wrapper" class="text-center">
    <div v-for="(val, key) in steps" class="step" :class="stepClass(key)" :key="key" :data-step="key+1">
      <p class="step_text">{{ val }}</p>
      <div class="step_doc"></div>
    </div>
  </div>
  <div id="checkout_prod_wrapper" class="box solid">
    <div class="box_title">
      <p class="title_text">{{ products[product].title }}</p>
      <p class="title_text prod_price">
        <span class="price_text">NT$ </span>
        <span class="price_text price">{{ products[product].price }}</span>
      </p>
    </div>
    <div class="box_content">
      <p class="box_text desc">{{ products[product].content }}</p>
    </div>
  </div>
  <div class="box checkout_form_wrapper">
    <form @submit="onSubmit">
      <slot/>
      <div class="box_content btn_wrapper row justify-content-center">
        <div class="col-12 col-sm-5" :class="hasPrevious?'order-sm-6':''">
          <button type="submit" class="btn primary lg step_submit" :data-step="currentStepIdx"
                  :disabled="!meta.valid || isSubmitting">
            <span class="btn_text">{{ okBtnText }}</span>
          </button>
        </div>
        <div v-if="hasPrevious" class="col-12 col-sm-5 order-sm-1">
          <button href="javascript:void(0);" class="btn cancel lg step_prev" :data-step="currentStepIdx" @click="goToPrev" :disabled="isSubmitting">
            <span class="btn_text">上一步</span>
          </button>
        </div>
      </div>

    </form>
  </div>
</template>

<script>
import {useForm} from "vee-validate";
import {ref, toRef, computed, provide} from "vue";
import {checkMailUsed} from "@vuePath/api/member"
import {checkoutPost} from "@vuePath/api/checkout";

export default {
  name: "FormWizard",
  emits: ["stepChange", "submit", "mailUsed"],
  props: {
    validationSchema: {
      type: Array,
      required: true,
    },
    initialValues: {
      type: Array,
      required: true,
    },
    product: {
      type: String,
      required: true
    },
    price: {
      type: String,
      required: true
    },
    initialStep: {
      type: Number,
      required: true
    },
    paidSuccess: {
      type: Boolean,
      default: false
    }
  },
  setup(props, {emit}) {
    const formData = ref({});
    const initialStep = toRef(props, 'initialStep')
    const currentStepIdx = ref(0);
    currentStepIdx.value = initialStep.value;

    // Injects the starting step, child <form-steps> will use this to generate their ids
    const stepCounter = ref(0);
    provide("STEP_COUNTER", stepCounter);
    // Inject the live ref of the current index to child components
    // will be used to toggle each form-step visibility
    provide("CURRENT_STEP_INDEX", currentStepIdx);

    const isSetMailStep = computed(() => {
      return currentStepIdx.value === 0;
    });

    const isSubmitStep = computed(() => {
      return currentStepIdx.value === stepCounter.value - 2;
    });

    const isLastStep = computed(() => {
      return currentStepIdx.value === stepCounter.value - 1;
    });

    const hasPrevious = computed(() => {
      return (currentStepIdx.value > initialStep.value) && !isLastStep.value;
    });

    const currentSchema = computed(() => {
      return props.validationSchema[currentStepIdx.value];
    });

    const formValues = computed(() => {
      return props.initialValues[currentStepIdx.value];
    });

    // vee-validate will be aware of computed schema changes
    const {meta, resetForm, handleSubmit, isSubmitting} = useForm({
      validationSchema: currentSchema,
      initialValues: formValues,
    });

    const okBtnText = computed(() => {
      if (isSubmitting.value) return "請稍候";
      if (isLastStep.value) return props.paidSuccess ? '確認' : '重新付款';
      return isSubmitStep.value ? "確認訂閱" : "確認";
    });

    const onSubmit = handleSubmit(async (values) => {
      formData.value = {
        ...formData.value,
        ...values,
      };

      if (isSetMailStep.value) {
        console.log('isSetMailStep');
        if (initialStep.value > 0) {
          currentStepIdx.value = initialStep.value;
          emit("stepChange", formData.value);
          return;
        }

        try {
          let checkMailResult = await checkMailUsed(values.email);

          console.log(checkMailResult);
          if (checkMailResult.data.data['email_used']) {
            emit("mailUsed");
            return;
          } else {
            ga('send', 'event', 'payment', 'click', values.email)
          }
        } catch (e) {
          console.log(e);
          return;
        }
      }

      if (!(isLastStep.value || isSubmitStep.value)) {
        console.log('other Step');
        currentStepIdx.value++;
        emit("stepChange", formData.value);

        return;
      }

      if (isSubmitStep.value) {
        console.log('isSubmitStep');
        try {
          console.log(JSON.stringify(formData.value, null, 2));
          let sendData = {
            'new_member': ((initialStep.value === 0) ? "1" : "0"),
            'email': formData.value['email'],
            'nickname': formData.value['nickname'],
            'password': formData.value['password'],
            'credit_card_no': formData.value['creditCard'].replace(/\s+/g, ''),
            'credit_card_exp': formData.value['creditMY'].replace(/(\w+)\s\/\s(\w+)/, '$2$1'),
            'credit_card_cvc': formData.value['creditCVV'],
            'invoice_type': formData.value['invoiceType'],
            'invoice_title': formData.value['invoiceTitle'],
            'invoice_uniform': formData.value['invoiceUniform']
          }
          console.log(JSON.stringify(sendData, null, 2));
          let result = await checkoutPost(props.product, sendData);
          console.log(result);
          if (result.data.code === "000") {
            emit("submit", {
              'paidEmail': ((result.data.data.email)),
              'paidSuccess': true
            });
          } else {
            emit("submit", {
              'errorMsg': result.data.message,
              'paidSuccess': false
            });
          }
          currentStepIdx.value++;

        } catch (e) {
          console.log(e);
          emit("submit", {
            'errorMsg': '系統錯誤',
            'paidSuccess': false
          });
        }
        return;
      }

      if (isLastStep.value) {
        console.log('isLastStep');
        if (props.paidSuccess) {
          window.location.href = window.location.origin
        } else {
          currentStepIdx.value = currentStepIdx.value - 2
          emit("stepChange", formData.value);
        }
      }
    });

    function goToPrev() {
      if (currentStepIdx.value === initialStep.value) {
        currentStepIdx.value = initialStep.value;
        return;
      }

      Object.keys(currentSchema.value.fields)
          .forEach((ObjectKey) => {
            if (formData.value.hasOwnProperty(ObjectKey)) delete formData.value[ObjectKey];
          });
      currentStepIdx.value--;
      emit("stepChange", formData.value);
    }

    function stepClass(currentStep) {
      if (isLastStep.value && (currentStep === (stepCounter.value - 1)) && !props.paidSuccess) return ((currentStep & 1) !== 0) ? 'sm ' : '';
      let text = "";
      return text.concat(((currentStep & 1) !== 0) ? 'sm ' : '', (currentStep <= currentStepIdx.value) ? 'active' : '');
    }

    return {
      meta,
      onSubmit,
      hasPrevious,
      isLastStep,
      goToPrev,
      stepClass,
      currentStepIdx,
      isSubmitting,
      okBtnText
    };
  },
  data() {
    return {
      steps: ['會員資料', '', '付款訊息', '', '訂閱完成'],
      products: {
        'trial': {
          'title': '月付方案(試閱優惠)',
          'content': '*試閱 NT$1優惠為新用戶獨享，次月起以原價NT$89計',
          'price': '1'
        },
        'monthly': {
          'title': '月付方案',
          'content': '',
          'price': '89'
        },
        'yearly': {
          'title': '年付方案',
          'content': '',
          'price': '899'
        },
      }
    }
  }
};
</script>
